import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./App.css";

import HomePage from "./pages/HomePage.js";

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
